import { toLogin } from '@/commons';
import { showError } from '@/commons/show-error.ts';
import { type ErrorTip, ErrorTipMode } from '@ts-max/axios';
import axios, { type AxiosError, type AxiosResponse } from 'axios';
import { t } from 'i18next';
import { isValidElement } from 'react';
import { isAxiosError } from './axios-error';

export function handleError(error: AxiosError | Error) {
  console.log(error);
  // 如果是请求被取消的错误，则不进行任何处理
  if (axios.isCancel(error)) return;

  // 如果需要登录，跳转到登录页面
  if (
    isAxiosError(error) &&
    error.response?.status === 401 &&
    error?.config?.toLogin !== false
  ) {
    return toLogin({ response: error.response });
  }

  // 如果errorTip为false，则不进行处理
  if (isAxiosError(error) && error.config) {
    const { errorTip = true } = error.config;
    if (!errorTip) return;
  }

  const title = getTitle(error);
  const mode = getMode(error);
  const message = getMessage(error);

  showError({ title, mode, content: message });
}

/**
 * 获取错误提示的标题
 * @param error
 */
function getTitle(error: AxiosError | Error) {
  let title = t('common:error');

  if (!isAxiosError(error)) return title;

  const errorTip = error.config?.errorTip;
  if (!errorTip) return title;

  if (typeof errorTip === 'object' && !isValidElement(errorTip)) {
    title = (errorTip as ErrorTip).title || title;
  }
  return title;
}

/**
 * 获取错误提示的模式
 * @param error
 */
function getMode(error: AxiosError | Error) {
  let mode = ErrorTipMode.message;

  if (!isAxiosError(error)) return mode;

  const errorTip = error.config?.errorTip;
  if (typeof errorTip === 'object' && !isValidElement(errorTip)) {
    mode = (errorTip as ErrorTip).mode || mode;
  }

  return mode;
}

/**
 * 获取错误提示的消息内容
 * @param error
 */
function getMessage(error: AxiosError | Error) {
  if (!isAxiosError(error)) return error.message;

  // 以用户自定义errorTip优先
  if (error.config) {
    const { errorTip = true } = error.config;

    if (typeof (errorTip as any) === 'string' || isValidElement(errorTip)) {
      return errorTip;
    }
  }

  // 如果没有自定义errorTip，使用返回的错误信息
  if (error.response) {
    const response: AxiosResponse = error.response!;
    const status = response?.status;

    if (status) {
      if (status === 403) return t('common:forbidden');
      if (status === 404) return t('common:not_found');
      if (status === 413) return t('common:payload_too_large');
      if (status >= 500) return t('common:server_error');
    }

    if (response?.data?.message) {
      return response?.data?.message;
    }
  }

  // 默认返回错误信息
  return error.message;
}
